import { channelsInstance } from '@/api/instances'

const fetch = async (store, channelId) => {
  store.commit('setHandoff', null)

  try {
    const responseBody = await channelsInstance.get(
      `channels/${channelId}/comments`
    )

    store.commit('setHandoff', responseBody)
  } catch (error) {
    /* eslint-disable no-console */
    console.error(error)
  }
}

const addComment = async (store, { channelId, comment, personId }) => {
  try {
    const responseBody = await channelsInstance.post(
      `channels/${channelId}/comment`,
      {
        json: { comment, personId }
      }
    )

    store.commit('addComment', responseBody)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'handoff/addComment' },
      { root: true }
    )
  }
}

const clearHandoff = store => {
  store.commit('setHandoff', null)
}

export default {
  fetch,
  addComment,
  clearHandoff
}
